<template>
  <div class="basic_text my_basic_text" @mouseenter="module_isHover(true)" @mouseleave="module_isHover(false)">
    <div class="tooptipPart">
      <template v-if="$store.state.app.view_pattern === 'pc'&&this.module.widgets_id !== this.editID"
                class="module_edit_btn">
        <my_edit_btn :module="module" :title="$t('widgets_basic_rich_text_index_2813')"></my_edit_btn>
        <my_edit_btn :module="module" tabName="animation" :title="$t('widgets_basic_article_classification_edit_330')"></my_edit_btn>
        <my_link_btn :module="module" :title="$t('components_my_link_index_2361')"></my_link_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index" :title="$t('widgets_basic_text_index_2865')"></my_close_btn>
      </template>
    </div>
    <div class="coverPart">
      <div class="contentPart" @dblclick="clickTime">
        <set_link class="linkPart" :sendData="module.data.listArr.link" v-if='module.widgets_id !== editID'></set_link>
        <div
          class="edit-div"
          :contenteditable="$store.state.app.view_pattern === 'pc'"
          :id="'editDiv' + module.widgets_id"
          @mousedown.stop
          @focus="isLocked = true"
          @blur="isLocked = false"
          @input="changeText"
          v-html="module.data.listArr.title"
          :style="{
            lineHeight: module.data.pc_widgets_infor.lineHeight === $t('view_back_top_edit_103') ? 1.5 : (module.data.pc_widgets_infor.lineHeight + 'px'),
            fontSize: module.data.pc_widgets_infor.fontSize + 'px',
            fontFamily: $utils.getFontFamily(module.data.pc_widgets_infor),
            textAlign: module.data.pc_widgets_infor.textAlign,
            fontWeight: module.data.pc_widgets_infor.fsWeight,
            fontStyle: module.data.pc_widgets_infor.fsItalics,
            textDecoration: module.data.pc_widgets_infor.fontUnderline,
            webkitBackgroundClip: 'text',
            webkitTextFillColor: module.data.pc_widgets_infor.pattern == 'linear_gradient' ? 'transparent' : '',
            color: module.data.pc_widgets_infor.pattern == 'pure_color' ? module.data.pc_widgets_infor.titleColor : '',
            backgroundImage:
              module.data.pc_widgets_infor.pattern == 'linear_gradient'
                ? 'linear-gradient(' +
                  module.data.pc_widgets_infor.linear_gradient.deg +
                  'deg,' +
                  module.data.pc_widgets_infor.linear_gradient.start_color +
                  module.data.pc_widgets_infor.linear_gradient.start_pointer +
                  '%,' +
                  module.data.pc_widgets_infor.linear_gradient.end_color +
                  module.data.pc_widgets_infor.linear_gradient.end_pointer +
                  '%)'
                : ''
          }"
        ></div>
        <!-- <my_div_edit
          class="textEdit"
          :value.sync="module.data.listArr.title"
          :module='this.module'
          @input="saveWrods"
          :style="{
            lineHeight: module.data.pc_widgets_infor.lineHeight === '默认'?'' : module.data.pc_widgets_infor.lineHeight + 'px',
            fontSize: module.data.pc_widgets_infor.fontSize + 'px',
            fontFamily: module.data.pc_widgets_infor.fontFamily,
            textAlign: module.data.pc_widgets_infor.textAlign,
            fontWeight: module.data.pc_widgets_infor.fsWeight,
            fontStyle: module.data.pc_widgets_infor.fsItalics,
            textDecoration: module.data.pc_widgets_infor.fontUnderline,
            webkitBackgroundClip: 'text',
            webkitTextFillColor: module.data.pc_widgets_infor.pattern == 'linear_gradient' ? 'transparent' : '',
            color: module.data.pc_widgets_infor.pattern == 'pure_color' ? module.data.pc_widgets_infor.titleColor : '',
            backgroundImage:
              module.data.pc_widgets_infor.pattern == 'linear_gradient'
                ? 'linear-gradient(' +
                  module.data.pc_widgets_infor.linear_gradient.deg +
                  'deg,' +
                  module.data.pc_widgets_infor.linear_gradient.start_color +
                  module.data.pc_widgets_infor.linear_gradient.start_pointer +
                  '%,' +
                  module.data.pc_widgets_infor.linear_gradient.end_color +
                  module.data.pc_widgets_infor.linear_gradient.end_pointer +
                  '%)'
                : ''
          }"
        ></my_div_edit> -->
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_text',
  data() {
    return {
      isHover: false,
      timer: null,
      isLocked: false,
    };
  },
  watch: {
    //去掉修改样式时候给予文字选中
    // 'module.data.pc_widgets_infor':{
    //   handler: function (val) {
    //     var range = document.createRange();
    //     range.selectNodeContents(document.getElementById('editDiv'+ this.module.widgets_id));
    //     window.getSelection().removeAllRanges();
    //     window.getSelection().addRange(range);
    //   },
    //   deep:true
    // },
    isLocked(val) {
      let htmlWord = $(`#u${this.module.widgets_id} .edit-div`).html()
      if (htmlWord === i18n.t('components_my_div_edit_index_2302') || this.module.data.listArr.title === i18n.t('components_my_div_edit_index_2302')) {
        this.module.data.listArr.title = ''
      } else if (!htmlWord && !val) {
        this.module.data.listArr.title = i18n.t('components_my_div_edit_index_2302')
      } else {
        this.module.data.listArr.title = htmlWord
      }
      if (val) {
        $('#u' + this.module.widgets_id)
          .find('.contentPart')
          .addClass('focusDiv');
        var range = document.createRange();
        range.selectNodeContents(document.getElementById('editDiv' + this.module.widgets_id));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      } else if (!val) {
        window.getSelection().removeAllRanges();
        $('#u' + this.module.widgets_id)
          .find('.contentPart')
          .removeClass('focusDiv');
        // this.templet.dialog_close()
      }
    },
    'module.data.listArr.title'(val) {
      if (val === '' && !this.isLocked) this.module.data.listArr.title = i18n.t('components_my_div_edit_index_2302')
    },
  },
  computed: {
    editID() {
      if (this.$store.state.app.module_Data) {
        return this.$store.state.app.module_Data.widgets_id
      } else {
        return 0
      }
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    }
  },
  methods: {
    changeText(val) {
      let htmlWord = $(`#u${this.module.widgets_id} .edit-div`).html()
    },
    clickTime() {
      if (this.$store.state.app.view_pattern !== 'pc') {
        return false;
      }
      let that = this;
      $('#u' + that.module.widgets_id)
        .find('.contentPart')
        .addClass('focusDiv');
      if (this.module.widgets_id === this.editID) {
        return false
      }
      var range = document.createRange();
      range.selectNodeContents(document.getElementById('editDiv' + this.module.widgets_id));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      // that.templet.set_focus(that.module.widgets_id);
    },
    module_isHover(val) {
      this.isHover = val;
    },
    saveWrods(data) {
      this.module.data.listArr.title = data;
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  created() {
    if (this.module.data.pc_widgets_infor.customFont === undefined || Array.isArray(this.module.data.pc_widgets_infor.customFont)) {
      this.$set(this.module.data.pc_widgets_infor, 'customFont', {
        name: '',
        url: ''
      })
    }
    if (!this.module.data.pc_widgets_infor.fontList) {
      this.$set(this.module.data.pc_widgets_infor, 'fontList', [])
    }
    if (this.module.data.pc_widgets_infor.customFont && this.module.data.pc_widgets_infor.customFont.name) {
      this.$utils.insertStyle(this.module.data.pc_widgets_infor.customFont)
    }
  },
  mounted() {
    // $('#u'+this.module.widgets_id +' .edit-div').focus()
    // $('#u'+this.module.widgets_id +' .edit-div').click()
  }
};
</script>

<style lang="scss" scoped>
.mb_pattern .basic_text {
  cursor: text;

  .contentPart {
    cursor: text;
  }
}

.basic_text:hover {
  .tooptipPart {
    display: block;
  }
}

.basic_text {
  .tooptipPart {
    right: 0;
    top: -28px;
    display: none;
  }

  .tooptipPart:hover {
    display: block;
  }
}

.basic_text {
  .textEdit {
    display: block;
    width: 100%;
    cursor: text;
    min-width: 10px;
    overflow: hidden;
    pointer-events: none;
  }
}

.contentPart.focusDiv {
  border: 1px dashed #5874d8;
  cursor: text;
}

.contentPart {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: move;

  .linkPart {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .linkPart.noClick {
    pointer-events: none;

    /deep/ .cover_anchor {
      pointer-events: none;
    }
  }
}

.coverPart {
  height: 100%;
}

.my_basic_text {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_text/index.vue